import { InjectionToken } from "@angular/core";

export const PARTY_SIGNUP_SETTINGS_TOKEN = new InjectionToken<any>('PARTY_SIGNUP_SETTINGS');

export const PARTY_SIGNUP_SETTINGS_PROVIDER = {
    provide: PARTY_SIGNUP_SETTINGS_TOKEN,
    useFactory: () => {
        return {
            qualifiedTaxDeductible: true,
            isDefault: true,
            dedicationEnabled: false,
            streetAddress: true,
            phoneNumber: true,
            additionalInfo: true,
            additionalInfoSelect: true,
            coCampaigns: true,
            addOnDonationCampaign: true,
            redirectUrl: true,
            donationButtonLabel: true,
            postDonation: false,
            internalId: true,
            campaignPageImage:true
        };
    }
};

export const PARTY_SIGNUP_SETTINGS_TYPE = new InjectionToken<string>('PARTY_SIGNUP_SETTINGS_TYPE');
export const PARTY_SIGNUP_ACCORDION_SETTINGS_TOKEN = new InjectionToken<any>('PARTY_SIGNUP_ACCORDION_SETTINGS_TOKEN');

export function partySignupAccordionSettingsFactory(type: string) {
  if (type === 'campaign') {
    return {
        general: { 
            expanded: false
        },
        coverFee: { 
            expanded: false
        },
        eMail: { 
            expanded: false
        },
        settings: { 
            expanded: false
        },
    };
  } 
  if (type === 'presetOption') {
    return {
        host: { 
            expanded: false
        },
        eventSettings: { 
            expanded: false
        },
        optionLiveTime: { 
            expanded: false
        },
    };
  }
  throw new Error(`Unknown type: ${type}`);
}

export const PARTY_SIGNUP_ACCORDION_SETTINGS_PROVIDER = {
    provide: PARTY_SIGNUP_ACCORDION_SETTINGS_TOKEN,
    useFactory: partySignupAccordionSettingsFactory,
    deps: [PARTY_SIGNUP_SETTINGS_TYPE],
};